import React, { useEffect, useRef, useState } from "react";
import { iterateDom, deepestTextNode, iterateDomUp, deepestTextNodeRight, cloneRecurvise, deepestEmptyOrTextNode } from "./editor3Utils";
import "./editor3.css";

export const Editor3 = ()=>{
    const editorRef = useRef<HTMLDivElement>(null);
    const [controller, setController] = useState<any>(null);
    
    useEffect(()=>{
        if (!editorRef.current){
            return
        }


        const tripleTextNode = (node: Node, startOffset: number, endOffset: number)=>{
            let prev;
            if (startOffset !=0){
                prev = document.createTextNode(node.textContent.slice(0, startOffset));
                node.parentElement.insertBefore(prev, node.nextSibling);
            }
            const wrapped = document.createElement('b');
            wrapped.className = "b";
            wrapped.textContent = node.textContent.slice(startOffset, endOffset);
            node.parentElement.insertBefore(wrapped, prev ? prev.nextSibling : node.nextSibling);
            let next;
            if (endOffset != node.textContent.length){
                next = document.createTextNode(node.textContent.slice(endOffset));
                node.parentElement.insertBefore(next, wrapped.nextSibling);
            }           
            node.parentElement.removeChild(node);
            return wrapped;
        }

        const removeParent = (node: Node) => {
            let boldNode: HTMLElement;
            iterateDomUp(node, (jt)=>{
                if (jt instanceof HTMLElement && jt.tagName == "B" && !boldNode){
                    boldNode = jt;
                }
            });
            boldNode.parentNode.replaceChild(node, boldNode);
        }
        
        const wrapBold = ()=>{
            const selection = document.getSelection();
            const range = selection.getRangeAt(0);
            const deepStart = deepestTextNode(range.startContainer, range.startOffset);
            const deepEnd = deepestTextNode(range.endContainer, range.endOffset);
            console.log(deepStart, deepEnd);
            let isStarted = false;
            let isEnded = false;
            let nodeList: Node[] = [];
            iterateDom(editorRef.current, [], (node, upperStack)=>{
                if (deepStart.node == deepEnd.node && deepStart.node == node){
                    isStarted = true;
                    isEnded = true;
                    if (deepStart.offset != deepEnd.offset){
                        nodeList.push(node);
                        console.log(node.textContent.slice(deepStart.offset, deepEnd.offset));
                        //const wrapped = tripleTextNode(node, deepStart.offset, deepEnd.offset);
                        //selection.setBaseAndExtent(wrapped.childNodes[0], 0, wrapped.childNodes[0], wrapped.textContent.length);
                    }
                }
                if ((node instanceof Text) && node == deepEnd.node && isStarted && !isEnded){
                    isEnded = true;
                    nodeList.push(node);
                    
                }
                if ((node instanceof Text) && isStarted && !isEnded){
                    nodeList.push(node);
                    
                }
                if ((node instanceof Text) && node == deepStart.node && !isEnded && !isStarted){
                    isStarted = true;
                    nodeList.push(node);
                    
                }
            });

            let isAllBold = true;
            nodeList.forEach(it=>{
                let hasBold = false;
                iterateDomUp(it, (jt)=>{
                    if (jt instanceof HTMLElement && jt.tagName == "B"){
                        hasBold = true;
                    }
                });
                if (!hasBold){
                    isAllBold = false;
                }
            });
            console.log(isAllBold ? 'all bold': ' not bold');
            if (isAllBold){
                nodeList.forEach(it=>removeParent(it));
                selection.setBaseAndExtent(nodeList[0], 0, nodeList[nodeList.length-1], nodeList[nodeList.length-1].textContent.length);
                return;
            }

            const firstNotEmpty = nodeList.findIndex((it, i)=>!((i==0 && it.textContent.length <= deepStart.offset) || it.textContent == ''));
            const lastNotEmpty = (nodeList.length -1) - ([...nodeList].reverse()).findIndex((it, i)=>!((i==0 && deepEnd.offset == 0) || it.textContent == ''));

            nodeList = nodeList.filter((it, i)=>{
                if (firstNotEmpty != -1 && i < firstNotEmpty){
                    deepStart.offset = 0; 
                    return false;
                } else
                if (lastNotEmpty != -1 && i > lastNotEmpty){
                    deepEnd.offset = nodeList[lastNotEmpty].textContent.length; 
                    return false;
                } else {
                    return it.textContent.length != 0;
                }
            });
            if (nodeList.length == 0){
                return;
            }

            console.log(nodeList);
            let wStart: Node;
            let wEnd: Node;
            nodeList.forEach((it, i)=>{
                if (i==0 && nodeList.length==1){
                    wStart = tripleTextNode(it, deepStart.offset, deepEnd.offset);
                    wEnd = wStart;
                } else if (i==0){
                    wStart = tripleTextNode(it, deepStart.offset, it.textContent.length);         
                } else if (i == nodeList.length-1){
                    wEnd = tripleTextNode(it, 0, deepEnd.offset)
                } else {
                    tripleTextNode(it, 0, it.textContent.length)
                }
            });
            selection.setBaseAndExtent(wStart.childNodes[0], 0, wEnd.childNodes[0], wEnd.textContent.length);
        }

        setController({
            addText: ()=>{
                const selection = document.getSelection();
                const range = selection.getRangeAt(0);
                const node = document.createElement('ul');
                const firstLi = document.createElement('li');
                node.appendChild(firstLi);
                /*const span = document.createElement('span');
                span.textContent = 'text';
                range.deleteContents();*/
                const el = isInsideText(range.endContainer);
                const li = isInsideLi(range.endContainer);
                if (li){
                    li.parentElement.insertBefore(node, li.nextSibling);
                    firstLi.innerHTML = li.innerHTML;
                    li.remove();
                    selection.setBaseAndExtent(firstLi, 0, firstLi, 0); 
                }else
                if (el){
                    el.parentElement.insertBefore(node, el.nextSibling);
                    selection.setBaseAndExtent(firstLi, 0, firstLi, 0); 
                }

                

                /*range.insertNode(node);//deleteContents();
                range.collapse();
                console.log(node);
                selection.setBaseAndExtent(firstLi, 0, firstLi, 0);*/
            },
            test: wrapBold
        });

        

        const isInsideLi = (node: Node): HTMLLIElement => {
            let result:HTMLLIElement = null;
            iterateDomUp(node, (current)=>{
                if (current instanceof HTMLLIElement && !result){
                    result = current;
                }
            });
            return result;
        }

        const isInsideText = (node: Node): HTMLElement => {
            let result:HTMLElement = null;
            iterateDomUp(node, (current)=>{
                if ((current instanceof HTMLParagraphElement) && !result){
                    result = current;
                }
            });
            return result;
        }

        const isInsideAnyTag = (node: Node): HTMLElement => {
            let result:HTMLElement = null;
            iterateDomUp(node, (current)=>{
                if ((current instanceof HTMLElement) && !result){
                    result = current;
                }
            });
            return result;
        }

        editorRef.current.innerHTML = "<p>"

        const splitBlock = (parent: Node | ((node: Node)=>boolean), node: Node, offset: number, onProcessNode?:(node: Node, cloned: Node)=>void, isFirst:boolean = false)=>{
            //const rightContainer = document.createDocumentFragment();
            //const rightParts: Array<Node> = [];

            let isStopped = false;
            let lastRightPart: Node;
            let lastLeftPart: Node;

            //let bottomNodeLeft: Node;
            //let bottomNodeRight: Node;
            iterateDomUp(node, (child)=>{
                if ((child != ((parent instanceof Node) ?parent : parent(child)) || isFirst) && !isStopped && child.parentNode){
                    //if (node instanceof HTMLElement){
                        if (child == ((parent instanceof Node) ?parent : parent(child)) && isFirst){
                            isStopped = true;
                            //isFirst = false;
                        }
                        isFirst = false;
                        let rightSplittedChild: Node;
                        let leftSplittedChild: Node;
                        if (child instanceof Text || child.childNodes.length == 0){
                            rightSplittedChild = child.cloneNode(false);
                            rightSplittedChild.textContent = child.textContent.slice(offset);
                            onProcessNode?.(child, rightSplittedChild);

                            leftSplittedChild = child.cloneNode(false);
                            leftSplittedChild.textContent = child.textContent.slice(0, offset);
                            //bottomNodeLeft = leftSplittedChild;
                            //bottomNodeRight = rightSplittedChild;
                        } else {
                            rightSplittedChild = lastRightPart;
                            leftSplittedChild = lastLeftPart;
                        }
                        const childIndex = [...child.parentNode.childNodes].findIndex(c=> c == child);
                        const rightPart = child.parentNode.cloneNode(false);
                        if (rightSplittedChild.textContent.length){
                            rightPart.appendChild(rightSplittedChild);
                        }
                        [...child.parentNode.childNodes].slice(childIndex + 1).forEach(it=>{
                            rightPart.appendChild(/*it.cloneNode(true)*/cloneRecurvise(it, onProcessNode));
                        });

                        const leftPart = child.parentNode.cloneNode(false);
                        
                        [...child.parentNode.childNodes].slice(0, childIndex).forEach(it=>{
                            leftPart.appendChild(cloneRecurvise(it));
                        });
                        if (leftSplittedChild.textContent.length){
                            leftPart.appendChild(leftSplittedChild);
                        }
                        lastRightPart = rightPart;
                        lastLeftPart = leftPart;
                        console.log(rightPart, leftPart);
                    //}
                } else {
                    isStopped = true;
                }
            });
            return {left: lastLeftPart, right: lastRightPart/*, bottomLeft: bottomNodeRight, bottomRight: bottomNodeRight*/};
        }

        const removeSelection = ()=>{
           
            const selection = document.getSelection();
            const range = selection.getRangeAt(0); 
            if (selection.isCollapsed){
                return false;
            }
            //const saved = {offset: range.endOffset, node: range.endContainer};
            const deepestNode = deepestEmptyOrTextNode(range.startContainer, range.startOffset);
            const deepestNodeRight = deepestEmptyOrTextNode(range.endContainer, range.endOffset);

            let deepestRightClone: {node: Node, offset: number};
            console.log(deepestNode, range.commonAncestorContainer);
            const {left, right: rightFull} = splitBlock(range.commonAncestorContainer, deepestNode.node, deepestNode.offset, (node, cloned)=>{
                if (node == deepestNodeRight.node){
                    deepestRightClone = {
                        node: cloned,
                        offset: range.endOffset - (node.textContent.length - cloned.textContent.length)
                    }
                }
            }, true);
            const {left: center, right} = splitBlock(rightFull, deepestRightClone.node, deepestRightClone.offset);

            const anc = range.commonAncestorContainer;
            if (anc instanceof Text){
                anc.textContent = left.textContent + right.textContent;
                selection.setPosition(anc, left.textContent.length);
            } else {
                const lastLeftNode = deepestTextNodeRight(left);
                const firstRightNode = deepestEmptyOrTextNode(right, 0);
                [...anc.childNodes].forEach(it=>it.parentNode.removeChild(it));
                [...left.childNodes].forEach(it=> anc.appendChild(it));
                [...right.childNodes].forEach(it=> anc.appendChild(it));
                if (lastLeftNode.node){
                    selection.setPosition(lastLeftNode.node, lastLeftNode.offset);
                } else {
                    selection.setPosition(firstRightNode.node, firstRightNode.offset);
                }
            }
            
            console.log(left, center, right);
            return true;
        }

        editorRef.current.onbeforeinput = (e)=>{
            e.preventDefault();
            console.log(e);
            if (e.inputType == 'deleteContentBackward'){
                const selection = document.getSelection();
                const range = selection.getRangeAt(0);
                const saved = {offset: range.endOffset, node: range.endContainer};
                const deepestNode = deepestTextNode(saved.node, saved.offset);

                //cloneRecurvise(editorRef.current);
                if (removeSelection()){
                    return;
                };
  
                //const deepestNodeRight = deepestTextNodeRight(saved.node, saved.offset);
                //console.log(deepestNodeRight);
                console.log(deepestNode?.node?.textContent[deepestNode.offset-1]);
                const el = isInsideText(range.endContainer);

                const previous = (node: Node, offset: number)=>{
                    console.log(node);
                    if (node && node instanceof Text && (node.textContent.length && offset != 0)){
                        return {node, offset}
                    }
                    if (!node || node instanceof HTMLParagraphElement){
                        return {node: null, offset};
                    }
                    while (!node.previousSibling) {
                        
                        node = node.parentNode;
                        if (node instanceof HTMLParagraphElement){
                            return {node: null, offset};
                            //break;
                        }
                        //return previous(node.parentNode, (node instanceof Text) ? node.textContent.length : 0);
                    }

                    node = node.previousSibling;

                    while (!(node instanceof Text)) {
                        node = node.childNodes[node.childNodes.length-1];
                        if (!node){
                            return {node: null, offset};
                        }
                        //return previous(node.parentNode, (node instanceof Text) ? node.textContent.length : 0);
                    }
                    //const prevText = (node.previousSibling instanceof Text) ? node.previousSibling : node.previousSibling.childNodes[node.previousSibling.childNodes.length-1];
                    return previous(node, node.textContent.length);
                }
                let prev = previous(deepestNode.node || saved.node, deepestNode.offset);
                if (prev && prev.node && prev.node.textContent[prev.offset-1] != undefined){
                    (prev.node as Text).replaceData(prev.offset-1, 1, ''); 
                    selection.setBaseAndExtent(prev.node, prev.offset-1, prev.node, prev.offset-1);

                    let foundTopEmpty: Node = null;
                    if (prev.node.textContent == ''){
                        console.log('empty');
                    }
                    iterateDomUp(prev.node, (node)=>{
                        if (node.textContent == '' && !(node instanceof HTMLElement && getComputedStyle(node).display== "block")){
                            foundTopEmpty = node;
                        }
                    });
                    if (foundTopEmpty){
                        prev = previous(prev.node, prev.offset);
                        if (!prev.node){
                            prev = deepestTextNode(foundTopEmpty.parentNode, 0) as any;
                        }
                        foundTopEmpty.parentNode.removeChild(foundTopEmpty);
                        selection.setBaseAndExtent(prev.node, prev.offset, prev.node, prev.offset);
                    }
                } 
                /*if (deepestNode?.node?.textContent[deepestNode.offset-1] != undefined){
                    (deepestNode.node as Text).replaceData(deepestNode.offset-1, 1, ''); 
                    selection.setBaseAndExtent(deepestNode.node, deepestNode.offset-1, deepestNode.node, deepestNode.offset-1);
                } else if (deepestNode?.node?.previousSibling instanceof Text && deepestNode?.node?.previousSibling?.textContent[deepestNode?.node?.previousSibling?.textContent.length-1] != undefined){
                    (deepestNode?.node?.previousSibling as Text).replaceData(deepestNode?.node?.previousSibling?.textContent.length-1, 1, ''); 
                    selection.setBaseAndExtent(deepestNode?.node?.previousSibling, deepestNode?.node?.previousSibling?.textContent.length, deepestNode?.node?.previousSibling, deepestNode?.node?.previousSibling?.textContent.length);
                }*/  else if (el && el.previousSibling && el.previousSibling instanceof HTMLElement){
                    console.log('remove block');
                    const saved = deepestTextNodeRight(el.previousSibling);
                    console.log(saved);

                    if (!saved.node){
                        saved.node = deepestTextNode(el, 0).node || el.previousSibling || el;
                    }
                    //const savedNode = el.previousSibling.childNodes?.[el.previousSibling.childNodes.length-1] || el.previousSibling;
                    //const savedOffset = (savedNode instanceof Text) ? savedNode.textContent.length : savedNode.childNodes.length;
                    [...el.childNodes].forEach(it=>{
                       el.previousSibling.appendChild(it);
                    });
                    //selection.setBaseAndExtent(el.previousSibling, el.previousSibling.childNodes.length, el.previousSibling, el.previousSibling.childNodes.length);
                    selection.setBaseAndExtent(saved.node, saved.offset, saved.node, saved.offset);
                    el.remove();
                }
            }
            if (e.inputType == 'insertText'){
                //e.preventDefault();
                const selection = document.getSelection();
                const range = selection.getRangeAt(0);
                //range.deleteContents();
                const saved = {offset: range.endOffset, node: range.endContainer};

                const deepestNode = deepestTextNode(saved.node, saved.offset);

                //if ((range.endContainer instanceof HTMLElement) && getComputedStyle(range.endContainer).display == 'block' && range.endContainer.childNodes.length == 0){
                if (!deepestNode.node){
                    const fixedData = e.data == ' '? "\u00A0" : e.data;
                    const textNode = document.createTextNode(fixedData);
                    const closeContainer = range.endContainer.childNodes?.[range.endOffset] || null;
                    //if (closeContainer){
                        range.endContainer.insertBefore(textNode, closeContainer);
                    //} else {
                      //  range.endContainer.appendChild(textNode);
                    //}
                    //;
                    selection.setBaseAndExtent(textNode, textNode.length, textNode, textNode.length);
                } else {
                    const fixedData = ((deepestNode.node.textContent[deepestNode.offset-1] == ' ' || deepestNode.offset == 0 || deepestNode.offset == deepestNode.node.textContent.length) && e.data == ' ') ? "\u00A0" : e.data;
                    (deepestNode.node as Text).insertData(deepestNode.offset, fixedData); 
                    selection.setBaseAndExtent(deepestNode.node, deepestNode.offset+ e.data.length, deepestNode.node, deepestNode.offset+ e.data.length);
                    //range.endContainer.textContent= range.endContainer.textContent.slice(0, range.endOffset) + e.data + range.endContainer.textContent.slice(range.endOffset);
                    //selection.setBaseAndExtent(saved.node, Math.min(range.endContainer.textContent.length, saved.offset+1), saved.node, Math.min(range.endContainer.textContent.length, saved.offset+1));
                }
                //console.log(range.endContainer);
                /*if (typeof range.endContainer.childNodes[range.endOffset] == 'string'){
                    selection.setBaseAndExtent(saved.node, Math.max(range.endContainer.textContent.length, saved.offset+1), saved.node, Math.max(range.endContainer.textContent.length, saved.offset+1));
                }*/
                //console.log(saved.node.textContent);
                //range.collapse();
                //selection.setBaseAndExtent(saved.node, Math.max(range.endContainer.textContent.length, saved.offset+1), saved.node, Math.max(range.endContainer.textContent.length, saved.offset+1));
            }
            if (e.inputType == 'insertParagraph'){
                //e.preventDefault();
                const selection = document.getSelection();
                const range = selection.getRangeAt(0);

                const liMode = isInsideLi(range.endContainer);
                if (liMode) {
                    const span = document.createElement('li');
                    //if (closeContainer){
                    liMode.parentElement.insertBefore(span, liMode.nextSibling);
                    //range.deleteContents();
                    //range.insertNode(span);
                    //range.selectNode(span);
                    selection.setBaseAndExtent(span, 0, span, 0); 
                    //range.collapse();
                    
                } else {
                    
                    let span = document.createElement('p');
                    const el = isInsideText(range.endContainer);
                    const {right, left} = splitBlock(el, range.endContainer, range.endOffset);
                    span = right as any || span;
                    if (left){
                        [...el.childNodes].forEach(it=>it.parentNode.removeChild(it));
                        [...left.childNodes].forEach(it=> el.appendChild(it));
                    }
                    /*iterateDom(el, [], (node)=>{
                        if (node ){

                        }
                    });*/
                    el.parentElement.insertBefore(span, el.nextSibling);
                    selection.setBaseAndExtent(deepestTextNode(span, 0).node || span, 0, deepestTextNode(span, 0).node || span, 0); 
                    //range.deleteContents();
                    //range.insertNode(span);
                    //range.collapse();
                }
            }
        }

        let lastLi: HTMLLIElement = null;
        let lastP: HTMLElement = null;
        const handleSelectionChange = ()=>{
            const selection = document.getSelection();
            const range = selection.getRangeAt(0);
            const li = isInsideLi(range.endContainer);
            const p = isInsideText(range.endContainer);
            //console.log(li);
            if (lastLi){
                lastLi.classList.remove('current-li');
            }
            if (li){
                li.classList.add('current-li');
                lastLi = li;
            }

            if (lastP){
                lastP.classList.remove('current-p');
            }
            if (p){
                p.classList.add('current-p');
                lastP = p;
            }
        }

        document.addEventListener('selectionchange', handleSelectionChange);

        return ()=>{
            //editorRef.current.onbeforeinput = null;
            document.removeEventListener('selectionchange', handleSelectionChange);
        }
    }, [editorRef.current]);

    return <div>
        editor v3
        <div>
            <button onClick={()=>controller.addText()}>tx</button>
            <button onClick={()=>controller.bold('bold')}>bold</button>
            <button onClick={()=>controller.bold('cursive')}>cursive</button>
            <button onClick={()=>controller.bold('underlined')}>underlined</button> 
            <button onClick={()=>controller.test()}>test</button>            
        </div>
        <div ref={editorRef} className={`editor3`} contentEditable="true"></div>
    </div>
}